import React, { useEffect, useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight, ChevronRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Get_Api } from '../../API_URL';
import { toast } from 'react-toastify';


const FeaturedOpenings = () => {
  const [loaded, setLoaded] = useState(false);

  const navigate = useNavigate()
  const [Alljobs, setAlljobs] = useState([]);
  const [Isloading, setIsloading] = useState(false);

  const GetAlljobs = async () => {
    try {
      setIsloading(true)
      const response = await Get_Api("api/admin/GetAllJobs");
      setAlljobs(response?.data || [])
      setIsloading(false)
    } catch (error) {
      setIsloading(false)
      toast.error(error?.response?.message || "Failed to upload requirement");
      console.error("Error uploading requirement:", error);
    }
  }

  useEffect(() => {
    GetAlljobs();
  }, []);

  const Loader = () => {
    return (
      <div className="flex items-center justify-center py-10 h-[400px]">
        <div className="w-10 h-10 border-4 border-[#01386A] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  };



  const [currentSlide, setCurrentSlide] = useState(0);

  // --- KEEN SLIDER CONFIG WITH AUTOPLAY ---
  const [sliderRef, instanceRef] = useKeenSlider(
    {
      initial: 0,
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      loop: true,
      slides: {
        perView: 1.1,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: { perView: 2.2, spacing: 20 },
        },
        '(min-width: 1024px)': {
          slides: { perView: 2.4, spacing: 20 },
        },
      },
    },
    [
      // --- AUTOPLAY PLUGIN ---
      (slider) => {
        let timeout;
        let mouseOver = false;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 3000); // 3 Seconds speed (Adjust here)
        }

        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      },
    ]
  );

  return (
    <section className="w-full py-20 bg-white font-sans">
      <div className="max-w-[1440px] mx-auto px-6 md:px-[80px]">

        <div className="flex justify-between items-end mb-[38px]">
          <h2 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] font-sora">
            Featured Openings
          </h2>

          {/* Arrows */}
          <div className="hidden md:flex gap-4">
            <button
              onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
              className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300"
            >
              <ArrowLeft size={18} />
            </button>
            <button
              onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
              className="w-[32px] h-[32px] rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center hover:bg-[#F06115] hover:text-white transition-all duration-300"
            >
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
        {Isloading ? (
          <Loader />
        ) : Alljobs.length > 0 ? (
          <div ref={sliderRef} className="keen-slider">
            {Alljobs?.map((job) => (
              <div key={job?._id} className="keen-slider__slide h-full">
                <div className="bg-[#F0F0F0] p-[20px] md:p-[40px] h-[330px] flex flex-col justify-between hover:shadow-lg transition-shadow duration-300 border border-transparent hover:border-gray-200">
                  <div>
                    <h3 className="text-[#01386A] lg:text-[20px] text-[16px] font-[500] font-graphik mb-[18px] leading-tight">
                      {job?.Title}
                    </h3>

                    <div className="space-y-3">
                      <p className="text-[#49577A] text-base font-medium flex items-center gap-2">
                        <span className="font-[600] font-graphik lg:text-[16px] text-[14px] leading-[24px]">Experience:</span>
                        <span className="font-[400] font-graphik lg:text-[16px] text-[14px] leading-[24px]">{job?.Experience} + years</span>
                        <span className="hidden md:inline text-[#01386A]">|</span>
                      </p>
                      <p className="text-[#49577A] text-base font-medium flex items-center gap-2">
                        <span className="font-[600] font-graphik lg:text-[16px] text-[14px] leading-[24px]">Location:</span>
                        <span className="font-[400] font-graphik lg:text-[16px] text-[14px] leading-[24px]">{job?.Location?.City} {job?.Location?.Country}</span>
                        <span className="hidden md:inline text-[#01386A]">|</span>
                      </p>
                    </div>
                  </div>

                  {/* Bottom Button */}
                  <Link
                    to={`/careers-apply/${job?._id}`}
                    className="w-full py-4 border border-[#ED6800] text-[#ED6800] font-[500] lg:text-[16px] text-[14px] font-graphik text-center flex items-center justify-center gap-2 hover:bg-[#ED6800] hover:text-white transition-all duration-300 mt-6"
                  >
                    Apply Now
                    <ChevronRight size={18} />
                  </Link>

                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-gray-500">
            No Open Positions Available
          </div>
        )}
        {/* Mobile Navigation (Visible only on small screens) */}
        <div className="flex md:hidden gap-4 mt-8 justify-center">
          <button
            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
            className="w-10 h-10 rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center"
          >
            <ArrowLeft size={18} />
          </button>
          <button
            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
            className="w-10 h-10 rounded-full border border-[#F06115] text-[#F06115] flex items-center justify-center"
          >
            <ArrowRight size={18} />
          </button>
        </div>

      </div>
    </section>
  );
};

export default FeaturedOpenings;